<template>
    <div class="temp-content">
        <!--查询筛选-->
        <div class="filter-wrap">
            <div class="filter-item">
                    <div class="filter-title">营地ID</div>
                    <div class="filter-element">
                        <t-input
                            placeholder="请输入营地ID"
                            :maxlength="12"
                            clearable
                            :size="inputSize" 
                        />
                    </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">营地名称</div>
                <div class="filter-element">
                    <t-input
                        placeholder="请输入营地名称"
                        :maxlength="60"
                        clearable
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">状态</div>
                <div class="filter-element">
                    <t-select
                    :options="statusType"
                    filterable
                    clearable
                    placeholder="请选择"
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">价格</div>
                <div class="filter-element-range">
                    <t-range-input
                        :placeholder="['最低价格', '最高价格']"
                        clearable
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    评分
                </div>

                <div class="filter-element-range">
                    <t-range-input
                        :placeholder="['最低评分', '最高评分']"
                        clearable
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    修改时间
                </div>

                <div class="filter-element-time">
                    <t-date-range-picker
                        format="YYYY-MM-DD HH:mm"
                        :enableTimePicker="true"
                        :placeholder="['开始时间', '结束时间']"
                        allowInput
                        clearable
                        
                    />
                </div>
            </div>

            <div class="filter-item">
                <div class="filter-title">
                    修改人
                </div>

                <div class="filter-element">
                    <t-input
                        placeholder="请输入修改人"
                        :maxlength="32"
                        clearable
                        :size="inputSize"
                        
                    />
                </div>
            </div>

            <div class="filter-button">
                <t-button>查询</t-button>
                <t-button variant="outline">重置</t-button>
                <t-button variant="outline">导出</t-button>
            </div>
        </div>

        <!--操作按钮-->
        <div  class="action-button">
            <t-button   @click="addClick">
                <template #icon><add-icon /></template>
                新增
            </t-button>
        </div>

        <!--营地列表-->
        <t-table
            tableLayout="fixed"
            :show-header="true"
            cell-empty-content="--"
            row-key="index"
            :data="campData" 
            :columns="columns"
            :pagination="pagination"
            @page-change="onPaginationChange"
            resizable
            lazy-load
            size="large"
            @row-click="handleRowClick"
            bordered
            hover
        >
            <!--营地主图-->
            <template #campInfo="{ row }">
                <div class="camp-info-wrap"> 
                    <img class="camp-image" :src="row.campImage" />
                    <div>{{ row.campName }}</div>
                </div>
            </template>

            <!--启用状态-->
            <template #isActive="{ row }">
                <span :class="{ 'status-inactive': row.isActive === '已停用' }">
                    {{ row.isActive }}
                </span>
            </template>

            <!--操作按钮-->
            <template #action="{ row }">
                <div class="table-action-button">
                    <t-link
                        class="edit-action"
                        theme="primary"
                        hover="color"
                        @click="detailClick(row)"
                    >
                        查看
                    </t-link>
                    <t-link
                        class="edit-action"
                        theme="primary"
                        hover="color"
                        @click="editClick(row)"
                    >
                        编辑
                    </t-link>

                    <t-link
                        class="status-action"
                        theme='primary'
                        hover="color"
                        @click="switchStatus(row)"
                    >
                        {{ row.isActive === '已启用' ? '停用' : '启用' }}
                    </t-link>

                    <t-link
                        v-if="row.isActive === '已停用'"
                        class="delete-action"
                        theme="danger"
                        hover="color"
                        @click="deleteItem(row)"
                    >
                        删除
                    </t-link>
                </div>
            </template>

        </t-table>
    </div>
</template>

<script setup lang="jsx">
    import { AddIcon} from 'tdesign-icons-vue-next';
    import { ref,onMounted } from 'vue';
    import { useRouter } from 'vue-router';
    import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
    import campAPI from '../../../api/camp-api';
    import { formatTime } from '../../../utils/datetime';

    const router = useRouter(); 

    /**
     * 初始化数据
     */
    // 表格列定义
    const columns=ref([
        { colKey: 'campId', title: '营地ID', width: '100' },
        { colKey: 'campInfo', title: '营地名称' },
        { colKey: 'price', title: '价格', width: 140},
        { colKey: 'rate', title: '评分', width: 100},
        { colKey: 'campType', title: '营地类型'},
        { colKey: 'isActive', title: '状态', width: 100},
        { colKey: 'updateTime', title: '修改时间', width: 180},
        { colKey: 'updateBy', title: '修改人' , width: 120},
        { colKey: 'action', title: '操作', width: 200},
    ]);

    // 初始化营地列表数据
    const campData = ref([]);

    const pagination = ref({
        total: 0,
        pageSize: 10,
        current: 1,
    });

    /**
     * 获取营地列表
     */
    const getCampList = async () => {
        try {
            const response = await campAPI.getCampList({
                page: pagination.value.current,
                per_page: pagination.value.pageSize,
            });
            
            // 处理返回的数据
            campData.value = response.camp_list_data.map(item => ({
                campId: item.id,
                campName: item.name,
                campImage: item.camp_image || '',
                price: item.price,
                campType: item.camp_type.map(ct => ct.name).join(', '),
                rate: item.rate,
                isActive: item.is_active ? '已启用' : '已停用',
                updateTime: formatTime(item.update_time),
                updateBy: item.update_by,
            }));

            // 设置总数
            pagination.value.total = response.total;
        } catch (error) {
            console.error('获取营地列表失败:', error);
            MessagePlugin.error('获取营地列表失败，请重试');
        }
    };

    // 监听分页变化
    const onPaginationChange = (pageInfo) => {
        pagination.value.current = pageInfo.current;
        pagination.value.pageSize = pageInfo.pageSize;
        getCampList();
    };

    // 在组件挂载时获取营地列表
    onMounted(() => {
        getCampList();
    });
    
    /**
     * 新增跳转
     */
    const addClick=()=>{
        router.push('/camp/camp-add');
    };

    /**
     * 查看详情跳转
     */
    const detailClick = (row) => {
        router.push({
            name: 'campDetail',
            params: { id: row.campId }
        });
    };

    /**
     * 编辑跳转
     */
    const editClick = (row) => {
        router.push({
            name: 'campEdit',
            params: { id: row.campId }
        });
    };

    /**
     * 修改营地状态
     */
    const switchStatus = async (row) => {
        const newStatus = row.isActive === '已停用';
        const actionText = newStatus ? '启用' : '停用';

        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: `确定${actionText}营地吗？`,
            confirmBtn: '确定',
            cancelBtn: '取消',
            width:400,
            onConfirm: async () => {
                try {
                    await campAPI.updateCampStatus(row.campId, newStatus);
                    row.isActive = newStatus ? '已启用' : '已停用';
                    MessagePlugin.success(`营地已${actionText}`);
                    getCampList(); // 重新获取列表以确保数据同步
                    dialog.destroy(); 
                } catch (error) {
                    console.error('修改状态失败:', error);
                    MessagePlugin.error(`${actionText}失败，请重试`);
                }
            },
            onClose: () => {
                dialog.destroy(); 
            }
        });
    };

    /**
     * 删除营地
     */
    const deleteItem = async (row) => {
        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: '确定删除该营地吗？',
            confirmBtn: '确定',
            cancelBtn: '取消',
            width:400,
            onConfirm: async () => {
                try {
                    await campAPI.deleteCamp(row.campId);
                    MessagePlugin.success('营地已删除');
                    getCampList(); // 重新获取列表
                    dialog.destroy();
                } catch (error) {
                    console.error('删除营地失败:', error);
                    MessagePlugin.error('删除营地失败，请重试');
                }
            },
            onClose: () => {
                dialog.destroy(); 
            }
        });
    };

</script>

<style scoped>
    @import "./camp-admin.css";
    @import "../../../components/style/style-content.css";
    @import "../../../components/style/style-table.css";
    @import "../../../components/style/style-filter.css";
</style>